export const CurricularActions = {
  GET_CURRICULAR: "GET_CURRICULAR",
  SET_CURRICULAR: "SET_CURRICULAR",

  
};
